import { FunctionalityModel } from './FunctionalityModel';

export interface ProfileModel {
    id: number,
    description: string,
    codeMetric: number | null,
    active?: boolean,
    functionalities: FunctionalityModel[]
}

export const profileModelInitial: ProfileModel = {
    id: 0,
    description: '',
    codeMetric: null,
    active: false,
    functionalities: []
};